import { SAGA_ACTIONS } from "src/_config";
import { LoginReq, LoginWithOtpReq } from "src/_common/interfaces/ApiReqRes";
import { useApiCall } from "../common/appApiCallHook";

export function useUserApi() {
  const callApi = useApiCall();

  const login = (data: LoginReq, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.LOGIN, data, onSuccess, onError);
  };

  const loginWithEmail = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.LOGIN, data, onSuccess, onError);
  };

  const autoLogin = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.AUTO_LOGIN, data, onSuccess, onError);
  };

  const verify2FA = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.VERIFY_2FA, data, onSuccess, onError);
  };

  const registration = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.REGISTRATION, data, onSuccess, onError);
  };

  const completeProfile = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.COMPLETE_PROFILE, data, onSuccess, onError);
  };

  const forgotPassword = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.FORGOT_PASSWORD, data, onSuccess, onError);
  };

  const resetPassword = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.RESET_PASSWORD, data, onSuccess, onError);
  };

  const getRegistrationFieldsData = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.REGISTRATION_FIELDS, data, onSuccess, onError);
  };

  const updateUserProfile = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.UPDATE_PROFILE, data, onSuccess, onError);
  };

  const getMe = (onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.DETAILS, null, onSuccess, onError);
  };

  const logout = (onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.LOGOUT, null, onSuccess, onError);
  };

  const deleteUser = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.DELETE_USER, data, onSuccess, onError);
  };

  const updateDisplayName = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.UPDATE_DISPLAY_NAME, data, onSuccess, onError);
  };

  const checkValidToken = (onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.CHECK_VALID_TOKEN, null, onSuccess, onError);
  };

  const saveNotification = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.SAVE_NOTIFICATION, data, onSuccess, onError);
  };

  const verifyEmail = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.VERIFY_EMAIL, data, onSuccess, onError);
  };

  const resendVerification = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.RESEND_VERIFICATION, data, onSuccess, onError);
  };

  const companyUploadLogo = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.COMPANY_UPLOAD_LOGO, data, onSuccess, onError);
  };

  const updateTwoFactorAuth = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.UPDATE_TWO_FACTOR_AUTH, data, onSuccess, onError);
  };

  // Job Posting APIs
  const createJob = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.JOB_POSTING.CREATE_JOB, data, onSuccess, onError);
  };

  const getUserPermissions = (userId: string | number, onSuccess: Function, onError: Function) => {
    const payload = { userId };
    callApi(SAGA_ACTIONS.USER.GET_PERMISSIONS, payload, onSuccess, onError);
  };

  const addCompanyBillingInfo = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.ADD_COMPANY_BILLING_INFO, data, onSuccess, onError);
  };

  const getCompanyBillingInfo = (onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.GET_COMPANY_BILLING_INFO, null, onSuccess, onError);
  };

  const getMyActivity = (params: { per_page?: number; page?: number }, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.MY_ACTIVITY, params, onSuccess, onError);
  };

  const getAllUsersActivity = (
    params: { per_page?: number; page?: number },
    onSuccess: Function,
    onError: Function
  ) => {
    callApi(SAGA_ACTIONS.USER.ALL_USERS_ACTIVITY, params, onSuccess, onError);
  };

  const deleteAccount = (onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.DELETE_ACCOUNT, {}, onSuccess, onError);
  };

  const getUserData = (onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.USER_DATA, {}, onSuccess, onError);
  };

  const getNotifications = (params: { per_page?: number; page?: number }, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.NOTIFICATIONS, params, onSuccess, onError);
  };

  return {
    callLogin: login,
    callAutoLogin: autoLogin,
    callUpdateUserProfile: updateUserProfile,
    callLogout: logout,
    callGetMe: getMe,
    callForgotPassword: forgotPassword,
    callDeleteUser: deleteUser,
    callRegistration: registration,
    callCompleteProfile: completeProfile,
    callResetPassword: resetPassword,
    callRegistrationFieldsData: getRegistrationFieldsData,
    callLoginWithEmail: loginWithEmail,
    callVerify2FA: verify2FA,
    callUpdateDisplayName: updateDisplayName,
    callCheckValidToken: checkValidToken,
    callSaveNotification: saveNotification,
    callVerifyEmail: verifyEmail,
    callResendVerification: resendVerification,
    callCompanyUploadLogo: companyUploadLogo,
    callUpdateTwoFactorAuth: updateTwoFactorAuth,
    callCreateJob: createJob,
    callGetUserPermissions: getUserPermissions,
    callAddCompanyBillingInfo: addCompanyBillingInfo,
    callGetCompanyBillingInfo: getCompanyBillingInfo,
    callGetMyActivity: getMyActivity,
    callGetAllUsersActivity: getAllUsersActivity,
    callDeleteAccount: deleteAccount,
    callGetUserData: getUserData,
    callGetNotifications: getNotifications,
  };
}
